import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { urlApi } from '../../../utils/apiConfig';

@Injectable()
export class BloqueadosService {
  constructor(private http: HttpClient) { 
    
  }

  public getBloqueados(): Observable<any> {
    return this.http.get(urlApi + '/app/blacklist');
  }

  public setBloquear(numero: string): Observable<any> {
    return this.http.post(urlApi + '/app/blacklist', { numero: numero })
  }

  public desbloquearNumero(numero: string): Observable<any>{
    return this.http.delete(urlApi+`/app/blacklist/${numero}`);
  }
}
